import { isNil } from 'lodash-es'

import {
  TDepositReturnAccount,
  TGuestDepositReturnAccount,
  TRefundAccount,
} from '@/entities/contract'
import { TAccount } from '@/entities/user'

import { TAccountFormValues } from './form'

export const convertAccountToFormValues = (
  account: TAccount,
): TAccountFormValues => {
  return {
    bankName: account.bankName?.trim() || '',
    bankAccount: account.bankAccount?.trim() || '',
    accountHolder: account.bankHolder?.trim() || '',
  }
}

export const convertDepositReturnAccountToFormValues = (
  depositReturnAccount?: Omit<
    TDepositReturnAccount,
    'isEditAvailable' | 'isDepositReturned'
  > | null,
): TAccountFormValues | null => {
  if (isNil(depositReturnAccount)) {
    return null
  }

  return {
    bankName: depositReturnAccount.depositReturnBankName?.trim() || '',
    bankAccount: depositReturnAccount.depositReturnBankAccount?.trim() || '',
    accountHolder: depositReturnAccount.depositReturnBankHolder?.trim() || '',
  }
}

export const convertRefundAccountToFormValues = (
  refundAccount?: Omit<TRefundAccount, 'isRefunded'> | null,
): TAccountFormValues | null => {
  if (isNil(refundAccount)) {
    return null
  }

  return {
    bankName: refundAccount.refundBankName?.trim() || '',
    bankAccount: refundAccount.refundBankAccount?.trim() || '',
    accountHolder: refundAccount.refundBankHolder?.trim() || '',
  }
}

export const convertFormValuesToAccount = (
  formValues: TAccountFormValues,
): TAccount => {
  return {
    bankName: formValues.bankName?.trim() || '',
    bankAccount: formValues.bankAccount?.trim() || '',
    bankHolder: formValues.accountHolder?.trim() || '',
  }
}

export const convertFormValuesToDepositReturnAccount = (
  formValues: TAccountFormValues,
): TGuestDepositReturnAccount => {
  return {
    depositReturnBankName: formValues.bankName?.trim() || '',
    depositReturnBankAccount: formValues.bankAccount?.trim() || '',
    depositReturnBankHolder: formValues.accountHolder?.trim() || '',
  }
}

export const convertFormValuesToRefundAccount = (
  formValues: TAccountFormValues,
): Omit<TRefundAccount, 'isRefunded' | 'refundedAt'> => {
  return {
    refundBankName: formValues.bankName?.trim() || '',
    refundBankAccount: formValues.bankAccount?.trim() || '',
    refundBankHolder: formValues.accountHolder?.trim() || '',
  }
}
